import React, { ForwardedRef, forwardRef, Fragment, useEffect, useRef, useState } from 'react';
import { VoucherContextType } from '../../../../../context/VoucherEntryContext';
import Container from '../../../../../constants/Container';
import SecHeading from '../../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../../constants/InputTextBox';
import { RiMoneyRupeeCircleLine } from 'react-icons/ri';
import Tabs from '../../../../../constants/AppTab';
import CashFormView from './forms/CashFormView';
import { EndBaseLine } from '../../../../../constants/AppSpace';
import { Button } from '../../../../../constants/Button';
import BankFormView from './forms/BankFormView';
import { GiTakeMyMoney } from 'react-icons/gi';
import { PiBankThin } from "react-icons/pi";
import { CiCreditCard1 } from "react-icons/ci";
import { IoCardOutline } from "react-icons/io5";
import { PiWallet } from "react-icons/pi";
import WalletsFormView from './forms/WalletsFormView';
import ChequeFormView from './forms/ChequeFormView';
import { LuIndianRupee } from 'react-icons/lu';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/store';
import { contraVoucherDataPost } from '../../../../../helpers/submitDataOnServer';
import { useDispatch } from 'react-redux';
import CardFormView from './forms/CardFormView';
import BillPrintView from '../../billing_entry/form/widgets/BillPrintView';
import { useReactToPrint } from 'react-to-print';

interface HeaderFormViewProps {
  context: VoucherContextType;
}
const DebitCreditBankView: React.FC<HeaderFormViewProps> = ({ context }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue, handleSubmit, handleChange, handleBlur, touched, errors } = context;
  const [onTabID, setOnTabID] = useState(0);
  const tabData = [
    { label: 'Cash', content: <CashFormView context={context} /> },
    { label: 'Bank', content: <BankFormView context={context} /> },
    { label: 'Wallets', content: <WalletsFormView context={context} /> },
    { label: 'Card', content: <CardFormView context={context} /> },
    { label: 'Cheque', content: <ChequeFormView context={context} /> },
  ];
  const tabIcons = [
    <GiTakeMyMoney />,
    <PiBankThin />,
    <PiWallet />,
    <CiCreditCard1 />,
    <IoCardOutline />,
  ];
  const creditAmountTrasField = useRef<HTMLInputElement | null>(null);
  const debitAmountTransField = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (values.is_debit === 1) {
      setFieldValue("creditamt", '');
      debitAmountTransField.current?.focus();
    } else {
      setFieldValue("debitamt", '');
      creditAmountTrasField.current?.focus();
    }
  }, [values.is_debit]);

  useEffect(() => {
    if (onTabID === 0) {
      setFieldValue("bank_sglsn", '');
      setFieldValue("chequeno", '');
      setFieldValue("bearername", '');
      setFieldValue("dep_particular_id", '');
    } else {
      setFieldValue("bank_sglsn", '');
      setFieldValue("chequeno", '');
      setFieldValue("bearername", '');
      setFieldValue("dep_particular_id", '');
    }
  }, [onTabID]);
  
  const { ContraVoucherAccountList, ContraVoucherInfo } = useSelector((state: RootState) => state.accounts);
  const totalDebitAmt = ContraVoucherAccountList?.reduce((sum, item) => {
    // Ensure item.debitamt is a number, default to 0 if it's undefined or NaN
    const debitamt = parseFloat(item.debitamt) ? parseFloat(item.debitamt) : 0;
    return sum + debitamt;
  }, 0);
  const totalCreditAmt = ContraVoucherAccountList?.reduce((sum, item) => {
    // Ensure item.debitamt is a number, default to 0 if it's undefined or NaN
    const creditamt = parseFloat(item.creditamt) ? parseFloat(item.creditamt) : 0;
    return sum + creditamt;
  }, 0);
  const handleSaveSubmit = async () => {
    await contraVoucherDataPost(ContraVoucherAccountList, ContraVoucherInfo, dispatch);
  };
  const RenderListComponent = forwardRef<HTMLDivElement, {}>((props, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div ref={ref}>
        <BillPrintView />
      </div>
    );
  });
  const componentListRef = useRef<HTMLDivElement | null>(null);

  const handlePrintCard = useReactToPrint({
  content: () => componentListRef.current!,
  onAfterPrint: () => {
    localStorage.removeItem("bill_no");
  },
});

  return (
    <Container padding={true}>
      <SecHeading type='add' icon={<RiMoneyRupeeCircleLine />} label='Add Entry' />
      <Grid container spacing={1}>
        <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
          <InputTextBox
            type='number'
            ref={debitAmountTransField}
            prefix={<LuIndianRupee />}
            label='Debit Amount'
            name='debitamt'
            handleChange={handleChange}
            handleBlur={handleBlur}
            disabled={values?.is_debit === 1 ? false : true || true}
            value={values.debitamt}
            placeholder='0.00'
            error={errors.debitamt}
            required={values?.is_debit === 0 ? false : true || true}
          />
        </Grid>

        <Grid item lg={6} md={6} xs={12} xl={6} sm={12}>
          <InputTextBox
            type='number'
            prefix={<LuIndianRupee />}
            label='Credit Amount'
            name='creditamt'
            ref={creditAmountTrasField}
            handleChange={handleChange}
            handleBlur={handleBlur}
            disabled={values?.is_debit === 0 ? false : true || true}
            value={values.creditamt}
            placeholder='0.00'
            error={errors.creditamt}
            required={values?.is_debit === 1 ? false : true || true}
          />
        </Grid>
        <Grid item lg={12} md={12} xs={12} xl={12} sm={12}>
          <Tabs setOnTabID={setOnTabID} tabs={tabData} icons={tabIcons} defaultTabIndex={0} />
        </Grid>

        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
          <EndBaseLine top={10}>
            {/* Show Save button if debit and credit amounts are equal and not zero */}
            {totalDebitAmt !== 0 && totalCreditAmt !== 0 && totalDebitAmt === totalCreditAmt && values.voucher_type === "2" && (
              <Button btn_type='save' onClick={handleSaveSubmit} type='button' el='button' />
            )}
            {/* Show Add button if debit and credit amounts are not equal, and voucher_type is "2" */}
            {values.voucher_type === "2" && (
              <Button btn_type='add' onClick={() => handleSubmit()} type='button' el='button' />
            )}
            {values.voucher_type === "1" && (
              <Fragment>
                <Button btn_type='print' label_btn='Print' onClick={handlePrintCard} type='button' el='button' />
                <Button btn_type='save' label_btn='Save' onClick={() => handleSubmit()} type='button' el='button' />
              </Fragment>
            )}
          </EndBaseLine>
        </Grid>
      </Grid>
      <div className='hidden'>
        <div ref={componentListRef}>
          <RenderListComponent />
        </div>
      </div>
    </Container>
  );
}

export default DebitCreditBankView;
